import { SnackBarM } from "@common/components/alert/snackbar/SnackBar"
import { PlaySoundM } from "@common/components/playSound/PlaySoundM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { useInterval } from "@common/utils/useInterval"
import { displayTimeSeconds } from "@data/utility/Utils"
import React, { useEffect } from "react"
import { StyleSheet, View } from "react-native"
import { State, TapGestureHandler } from "react-native-gesture-handler"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { Tooltip } from "react-native-paper"

export const CHRONO_ORANGE_LIMIT = 95
export const CHRONO_RED_LIMIT = 101

export const calculateTimerColor = (timerProgress, status, whiteMode = false) =>
    timerProgress < CHRONO_ORANGE_LIMIT
        ? status !== "finished"
            ? whiteMode
                ? theme.colors.white
                : theme.colors.primary
            : theme.colors.success
        : theme.colors.warning

const TimerContainer = (props) => {
    // ** Component props
    const {
        time,
        setTime,
        status,
        setStatus,
        estimatedDuration,
        activityPaused,
    } = props

    useEffect(() => {
        if (activityPaused) {
            setStatus("paused")
        } else if (status === "paused") {
            setStatus("ongoing")
        }
    }, [activityPaused])

    const onMultiTap = (event) => {
        if (event.nativeEvent.state === State.ACTIVE) {
            if (status === "ongoing") setTime(Number.isInteger(time) ? time + 10 * 60 : 10 * 60)
        }
    }

    // ** Custom setInterval handler compatible with hooks (cf https://overreacted.io/making-setinterval-declarative-with-react-hooks/)
    useInterval(
        () => {
            setTime(time + 1)
        },
        status === "ongoing" ? 1000 : null,
    )

    const timerProgress = (time * 100) / (estimatedDuration)
    const timerColor = calculateTimerColor(timerProgress, status)

    useEffect(() => {
        if (
            time === Math.round((estimatedDuration * CHRONO_ORANGE_LIMIT) / 100)
        ) {
            SnackBarM.show({
                text1: "⏳ Tu as bientôt atteint la durée prévue",
                duration: 4000,
            })
            PlaySoundM.play(
                require("../../../../assets/sounds/question_002.mp3"),
            )
        } else if (
            time === Math.round((estimatedDuration * CHRONO_RED_LIMIT) / 100)
        ) {
            SnackBarM.show({
                text1: "⏳ Tu as dépassé la durée prévue",
                duration: 4000,
            })
            PlaySoundM.play(require("../../../../assets/sounds/error_003.mp3"))
        }
    }, [time])

    return (
        <View style={{ flex: 1, alignItems: "center", justifyContent: "center", alignSelf: "center" }}>
            <Tooltip title={estimatedDuration - time > 0 ? "Temps restant" : "Temps dépassé"} enterTouchDelay={100} leaveTouchDelay={1500}
                     titleMaxFontSizeMultiplier={0.5}>
                <TapGestureHandler
                    onHandlerStateChange={onMultiTap} numberOfTaps={30}>
                    <View style={styles.wrapper}>
                        <FontAwesome5 name={activityPaused ? "pause" : "stopwatch"} solid style={{ marginRight: 6 }} color={timerColor} size={15} />
                        <TextM fontWeight="SemiBold" color={timerColor} fontSize={14}>
                            {displayTimeSeconds(estimatedDuration - time)}
                        </TextM>
                    </View>
                </TapGestureHandler>
            </Tooltip>
        </View>
    )
}

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: theme.colors.whiteAlmost,
        borderRadius: 10,
        paddingHorizontal: 6,
        paddingVertical: 4,
        width: 80,
        marginRight: 15,
    },
})

export default TimerContainer
